import { ValidationResultModel } from "components/models"
import { GroupTagEditRequest } from "components/pages/maintanance/groupTag/groupTagForm/groupTagForm.models"
import {
  GroupTagRequest,
  GroupTagGridResponse,
  GroupTag,
} from "components/pages/maintanance/groupTag/groupTagList/groupTagList.models"
import EbateAxios from "queries/ebateAxios"
import { useState, useEffect } from "react"
import { dropdownUtils } from "components/helpers"

const tagUrl = "/api/GroupTag"

export const getGroupTagGridData = async (
  data: GroupTagRequest,
  abortSignal?: AbortSignal
) => {
  const url = `${tagUrl}/GetTagGridData`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<GroupTagRequest, GroupTagGridResponse>(
    url,
    data,
    abortSignal
  )
}

export const useGroupTagList = () => {
  const [data, setData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const onCompletedGroupTags = (data: any) =>
    dropdownUtils.mapToDropDownOptionFromApi(data)

  useEffect(() => {
    const fetchData = async () => {
      const response = await getGroupTag()
      if (response?.status === 200) {
        setData(onCompletedGroupTags(response.data))
      } else {
        setData([])
      }
      setIsLoading(false)
    }
    fetchData()
  }, [])

  return { data, isLoading }
}

const getGroupTag = async () => {
  const { AxiosGet } = EbateAxios()
  return AxiosGet<any[]>(`${tagUrl}/Get`)
}

export const addGroupTag = async (text: string) => {
  const url = `${tagUrl}/Add`
  const { AxiosPost } = EbateAxios()

  return AxiosPost<any, ValidationResultModel>(url, text)
}

export const updateGroupTag = async (data: GroupTagEditRequest) => {
  const url = `${tagUrl}/Update`
  const { AxiosPut } = EbateAxios()

  return AxiosPut<GroupTagEditRequest, ValidationResultModel>(url, data)
}

export const deleteGroupTag = async (id: number) => {
  const url = `${tagUrl}/Delete/${id}`
  const { AxiosPut } = EbateAxios()

  return AxiosPut<any, ValidationResultModel>(url, {})
}
